module.exports = __webpack_public_path__ + "img/portrait.00000622.jpg";